/**
 * Directiva utilizada para ver y añadir inspecciones a las incidencias
 */
CostesDetallesDirectiva.$inject = [];
export default function CostesDetallesDirectiva() {
    return {
        restrict: 'AE',
        scope: {
            'tareaId': '='
        },
        template: require('./costes-detalles.html'),
        controller: 'CostesDetallesCtrl as costDet',
        bindToController: true
    }
}